import omit from 'lodash/omit';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Stack from '@mui/material/Stack';

import AppDashboard from '../AppDashboard';
import CustomSelect from '../../components/common/CustomSelect';
import ListReports from '../../components/reports/ListReports';
// import WeeklyProviderActuationSummaryReport from '../../components/reports/WeeklyProviderActuationSummaryReport';
import {useGetReportsQuery} from '../../redux/services/reportApi';
import {getReportNames} from '../../helpers/reports';

const parseSearchParams = (searchParams) => {
  const filter = searchParams.entries().reduce((acc, [key,value]) => (
    ['report_name', 'id', 'creator_id', 'status'].includes(key)
    && ![null, undefined, ''].includes(value)
    ? {...acc, [key]: value}
    : acc
  ), {});
  return filter;
};

const handleFilterChange = ({setFilter, setSearchParams}) => filter => {
  setSearchParams(filter || {});
  setFilter(filter || {});
};

const ListReportFilters = ({
  filter, 
  onFilterChange
}) => (
  <Stack 
    direction='row' 
    spacing={1} 
    style={{paddingLeft: '1.8em', marginBottom: '2em'}}
  >
    <CustomSelect
      options={getReportNames().map(r => ({value: r.key, label: r.name}))}
      defaultValue={filter?.report_name}
      onChange={(e, val) => onFilterChange(
        e?.target?.value
        ? {...filter, report_name: e.target.value}
        : omit(filter, 'report_name')
      )}
      label="Report Type"
      maxWidth='300px'
      fullWidth
    />
  </Stack>
);

const ViewReportPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState(parseSearchParams(searchParams));
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const query = useGetReportsQuery(
    {
      ...filter,
      skip: pageIndex * pageSize,
      limit: pageSize,
    },
    {pollingInterval: 10000}
  );
  return (
    <AppDashboard
      title={'Generated Reports'}
      loading={query.isLoading}
    >
      <ListReportFilters 
        filter={filter}
        onFilterChange={handleFilterChange({setFilter, setSearchParams})}
      />
      <ListReports
        reports={query?.data?.data || []}
        pageIndex={pageIndex}
        pageSize={pageSize}
        count={query?.data?.count || 0}
        onPageChange={(e, num) => setPageIndex(num)}
        onRowsPerPageChange={e => setPageSize(parseInt(e.target.value, 10))}
      />
    </AppDashboard>
  );
};

export default ViewReportPage;